import {
  accessAuthHeaders,
  clearAccessToken,
  readAccessToken,
  writeAccessToken,
} from '../../lib/access-token-storage.js'

/**
 * Jeton d'accès à une demande, obtenu par le lien d'un message ou par le mur du
 * nom (voir `access-token-storage.ts`).
 */
export const readEstimateToken = (estimateId: string): null | string =>
  readAccessToken('estimate', estimateId)

export const writeEstimateToken = (estimateId: string, token: string): void =>
  writeAccessToken('estimate', estimateId, token)

export const clearEstimateToken = (estimateId: string): void =>
  clearAccessToken('estimate', estimateId)

export const estimateAuthHeaders = (estimateId: string): Record<string, string> =>
  accessAuthHeaders('estimate', estimateId)
